/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 8th 2022, 3:09:38 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Edit as EditIcon } from "react-feather";
import IconButton from "@mui/material/IconButton";
import { COLORSCHEME } from "theme/styles";

export const APIMany2OneEditButton = ({ objectId, onClick }) =>
  objectId ? (
    <IconButton onClick={onClick}>
      <EditIcon color={COLORSCHEME.primary} />
    </IconButton>
  ) : null;
